/*
CUSTOM-KITCHENARY
Homepage collection carousel loop
*/
(function () {

  function initCarousel(slider) {

    if (!slider.closest('[data-testid="collections-list-grid"]')) return;

    const scroller = slider.querySelector('[ref="scroller"]');
    const prevBtn = slider.querySelector('button[ref="previous"]');
    const nextBtn = slider.querySelector('button[ref="next"]');

    if (!scroller || !prevBtn || !nextBtn) return;

    function keepButtonsEnabled() {
      prevBtn.disabled = false;
      nextBtn.disabled = false;
      prevBtn.removeAttribute('disabled');
      nextBtn.removeAttribute('disabled');
    }

    keepButtonsEnabled();

    function slideWidth() {
      const slide = scroller.querySelector('.resource-list__slide');
      if (!slide) return 0;

      const gap = parseFloat(getComputedStyle(scroller).gap || 0) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return scroller.scrollWidth - scroller.clientWidth;
    }

    function slidesPerMove() {
      return window.innerWidth <= 768 ? 2 : 4;
    }

    function next() {
      const step = slideWidth() * slidesPerMove();
      const current = scroller.scrollLeft;
      const max = maxScroll();

      if (current >= max - 5) {
        scroller.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        scroller.scrollBy({ left: step, behavior: 'smooth' });
      }
    }

    function prev() {
      const step = slideWidth() * slidesPerMove();
      const current = scroller.scrollLeft;
      const max = maxScroll();

      if (current <= 5) {
        scroller.scrollTo({ left: max, behavior: 'smooth' });
      } else {
        scroller.scrollBy({ left: -step, behavior: 'smooth' });
      }
    }

    const observer = new MutationObserver(function () {
      keepButtonsEnabled();
    });

    observer.observe(prevBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    observer.observe(nextBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      next();
    }, true);

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      prev();
    }, true);
  }

  function init(root) {
    (root || document)
      .querySelectorAll('slideshow-component.resource-list__carousel')
      .forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e){
    init(e.target);
  });

})();